import React, { useEffect, useState } from 'react';

const InteractiveBackground = () => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Generate static particles to avoid hydration mismatches if using SSR logic, 
    // but here client-side generation is fine.
    const particleCount = 50;
    const newParticles = [];

    for (let i = 0; i < particleCount; i++) {
        newParticles.push({
            id: i,
            left: Math.random() * 100,
            top: Math.random() * 100,
            size: Math.random() * 3 + 1, // 1px to 4px
            duration: Math.random() * 10 + 10, // 10s to 20s
            delay: Math.random() * 5,
            opacity: Math.random() * 0.5 + 0.1
        });
    }
    setParticles(newParticles);
  }, []);

  return (
    <div className="fixed inset-0 -z-10 w-full h-full bg-[#020205] overflow-hidden">
      {/* Deep dark gradient overlay for subtle depth */}
      <div className="absolute inset-0 bg-gradient-to-b from-black via-[#050510] to-black opacity-80"></div>

      {/* Flowing Glitter Particles */}
      {particles.map((p) => (
        <div
          key={p.id}
          className="absolute rounded-full bg-white animate-flow-glitter"
          style={{
            left: `${p.left}%`,
            top: `${p.top}%`,
            width: `${p.size}px`,
            height: `${p.size}px`,
            opacity: p.opacity,
            animationDuration: `${p.duration}s`,
            animationDelay: `-${p.delay}s`,
            boxShadow: `0 0 ${p.size * 2}px rgba(255, 255, 255, 0.8)` // Glow effect
          }}
        />
      ))}
    </div>
  );
};

export default InteractiveBackground;
